
import { defineComponent } from 'vue'
import Window from '@/components/Window.vue'
import StartingUp from '@/components/StartingUp.vue'



export default defineComponent({
  name: 'App',
  components: {
    Window,
    StartingUp,
  },
  data() {
    return {
      starting: true,
      show: false,
      minimized: [] as string[],
    }
  },
  methods: {
    start() {
      this.starting = false
      setTimeout(() => {
        this.reopen('aSearch')
      }, 500)
    },
    open(name: string) {
      this.minimized = this.minimized.filter((item) => item != name)
      this.show = true
    },
    reopen(name: string) {
      this.minimized = this.minimized.filter((item) => item != name)
      this.show = true
    },
    close() {
      this.show = false
    },
    minimize() {
      this.show = false
      this.minimized.push('aSearch')
    },
  },
})
